import React, { useState } from 'react'
import { getMemberSince, getPosttype, handleClientProfileNavigation } from './AllDateTimeReleventFormate'
import CloudStorage from '../../CloudStorage/CloudStorage'
import { useNavigate } from 'react-router-dom';
import ProfileImageWithFallback from '../../common/ProfileImageWithFallback';

export default function AbouttheClient({ posts }) {
    const laung = localStorage.getItem("laung");
    const [lan, setLan] = useState(laung ?? "en");
    const navigate = useNavigate();

    const navigatetodetailpage = () => {
        handleClientProfileNavigation(posts?.type);
        navigate(`/${lan}/expertsprofiledetails/${posts?.user?.id}`);
    }
    return (
        <div onClick={() => { navigatetodetailpage() }} className="second-sec">
            <p className='justify-content-center'>About the Client </p>
            <div className='text-center pt-2'>
                <ProfileImageWithFallback url={posts?.user?.profile_image} style={{ width: '60px', height: '60px', borderRadius: 50 }} />

                <h4>
                    {posts?.user?.first_name} {posts?.user?.last_name}
                </h4>

                <p className='justify-content-center pb-3'>
                    <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/green-star.svg`}
                        alt=""
                    />&nbsp;&nbsp;
                    {posts?.user?.rating} ({posts?.user?.reviews} reviews)
                </p>
            </div>
            <div className="members">
                <p>Member since {getMemberSince(posts?.user?.created_on)} </p>
                <p style={{
                    minWidth: 'max-content',
                    justifyContent: 'unset',
                    maxWidth: '100%'
                }}>
                    <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/verified.svg`}
                        alt=""
                    />
                    Verified
                </p>
            </div>
            <div className="members">
                <p>
                    <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                        alt=""
                    />
                    Location:
                </p>
                <p>{posts?.user?.country}</p>
            </div>
            <div className="members">
                <p>
                    {posts?.user?.posts} {getPosttype(posts?.type)} posted
                </p>
                <p>
                    {posts?.user?.active_posts} open {getPosttype(posts?.type)}
                </p>
            </div>
            <div className="members">
                <p>
                    <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                        alt=""
                    />
                    Verified Payment
                </p>
            </div>
        </div>
    )
}
